import React, { useEffect } from "react";
import "./Work.css";
import Navbar from "../Shared/Navbar";
import { makeStyles } from "@material-ui/core/styles";
import GitHubIcon from "@material-ui/icons/GitHub";
import LinkIcon from "@material-ui/icons/Link";

import resumeData from "../../resumeData/resumeData";
import Footer from "../Home/Footer/Footer";

import AOS from "aos";
import "aos/dist/aos.css";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  image: {
    width: "100%",
    height: "100%",
  },
  img: {
    margin: "auto",
    display: "block",
    maxWidth: "100%",
    maxHeight: "100%",
  },
}));

const Work = () => {
  useEffect(() => {
    AOS.init({
      duration: 2000,
      offset: 180,
    });
  }, []);

  const projects = resumeData[0].projects;

  const classes = useStyles();

  return (
    <main id="work">
      <Navbar />

      <section className="container-fluid px-sm-5">
        <div className="work-container">
          <div className="project-container mt-5">
            {projects.map((project, index) => {
              return (
                <div
                  key={index}
                  data-aos={project.animation}
                  className="project-card mt-5 mb-5"
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                    }}
                  >
                    {/* Main Project Image */}
                    <img
                      className={`grid-image ${classes.img}`}
                      alt={project.titleHead || "Project"}
                      src={project.image}
                    />

                    {/* Second Project Image */}
                    {project.image2 && (
                      <img
                        className={`grid-image ${classes.img}`}
                        alt={project.titleHead || "Project"}
                        src={project.image2}
                      />
                    )}
                  </div>

                  <div>
                    <h3>{project.titleHead}</h3>

                    <ul
                      style={{
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      {project.description?.map((des, index) => (
                        <li key={index}>{des}</li>
                      ))}
                    </ul>

                    <h6 className="technology mt-lg-5">
                      {project.technology.map((tech, index) => (
                        <span key={index}>{tech}</span>
                      ))}
                    </h6>

                    <div className="button-container">
                      <div className="button-group">
                        <a
                          href={project.github}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <GitHubIcon />
                        </a>

                        <a
                          href={project.url}
                          className="link-icon"
                          target="_blank"
                          rel="noreferrer"
                        >
                          <LinkIcon />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <Footer />
    </main>
  );
};

export default Work;
